// src/components/modals/ErrorModal.js
import React from 'react';
import './ErrorModal.css';

/**
 * Modal for displaying validation errors and other error messages
 */
function ErrorModal({ show, onClose, title, errors }) {
  if (!show) return null;

  // Ensure errors is always an array
  const errorList = Array.isArray(errors) ? errors : [errors];

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content error-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header error-header">
          <h3>⚠️ {title || 'Validation Error'}</h3>
          <button className="modal-close" onClick={onClose}>
            ✕
          </button>
        </div>

        <div className="modal-body">
          <p className="error-intro">
            {errorList.length === 1
              ? 'The following issue was found:'
              : `${errorList.length} issues were found:`}
          </p>

          <ul className="error-list">
            {errorList.map((error, index) => (
              <li key={index} className="error-item">
                <span className="error-bullet">•</span>
                <span className="error-text">{error}</span>
              </li>
            ))}
          </ul>

          <div className="error-footer-note">
            <span className="info-icon">ℹ️</span>
            <span>Please fix these issues and try again.</span>
          </div>
        </div>

        <div className="modal-footer">
          <button className="modal-btn primary" onClick={onClose}>
            OK
          </button>
        </div>
      </div>
    </div>
  );
}

export default ErrorModal;
